/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as TeamDefs from './defs.defs.js'

const $nsid = 'tools.ozone.team.updateMember'

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  did: /*#__PURE__*/ l.string({ format: 'did' }),
  disabled: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  role: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{
      knownValues: [
        'tools.ozone.team.defs#roleAdmin',
        'tools.ozone.team.defs#roleModerator',
        'tools.ozone.team.defs#roleVerifier',
        'tools.ozone.team.defs#roleTriage',
      ]
    }>(),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.payload(
  'application/json',
  /*#__PURE__*/ l.ref<TeamDefs.Member>((() => TeamDefs.member) as any),
)

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Update a member in the ozone service. Requires admin role. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'MemberNotFound',
])

export { main }

export const $lxm = $nsid
